import React, { memo, useCallback, useMemo } from "react";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import a11y from "../../../../../../shared-components/css-modules/lexus/utils/Accessibility.module.scss";
import styles from "../ConfigCtas.module.scss";
import { trackClickSideSaveConfig } from "../../../../../utils/tracking";
import { useCarConfigSelector } from "../../../../../redux/store";
import Tooltip from "../../../../../../shared-components/css-modules/lexus/vendor/tooltip/Tooltip";
import { postalPublish } from "../../../../../../../../common-deprecated/utils/postalUtils";
import {
    POSTAL_CHANNEL_T1_CARCONFIG,
    POSTAL_TOPIC_CARCONFIG_SAVE_CONFIG,
} from "../../../../../../../../common-deprecated/constants";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

const Save: React.FC = () => {
    const section = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);
    const save = useCarConfigSelector((state) => state.save);
    const tyCode = save?.data?.Personal?.Code || save.data?.ConfigurationCode || "";

    const onClick = useCallback(() => {
        trackClickSideSaveConfig(section);
        postalPublish({
            channel: POSTAL_CHANNEL_T1_CARCONFIG,
            topic: POSTAL_TOPIC_CARCONFIG_SAVE_CONFIG,
            data: { configCode: tyCode },
        });
    }, [section, tyCode]);

    return useMemo(
        () =>
            tyCode ? (
                <Tooltip placement="left">
                    <Tooltip.Trigger>
                        <Button variant="clean" className={styles.link} onClick={onClick}>
                            <Icon variant="bookmark" sizing="md" aria-hidden="true" />
                            <span className={a11y["sr-only"]}>
                                <CarConfigLabel label="carConfigActionsSaveButtonLabel" />
                            </span>
                        </Button>
                    </Tooltip.Trigger>
                    <Tooltip.Content className={styles.popover}>
                        <CarConfigLabel label="carConfigActionsSaveButtonLabel" />
                    </Tooltip.Content>
                </Tooltip>
            ) : null,
        [tyCode],
    );
};

export default memo(Save);
